
// 配置审图要点 中文版

const kte_checklist_zh = [
    {
        "name": "建筑专业-总图",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 地下车库出入口（含非机动）、人防口部、地下泵房、箱变、消防取水口、化粪池、出风口等功能部位设置正确合理，对建筑无不良影响。",

                            },
                            {
                                "name": "2. 广场、停车场、运动场地、道路、无障碍设施、排水沟、挡土墙、护坡等的定位是否正确，标高、坡度是否正确、合理。",

                            },
                            {
                                "name": "3. 通行车道的转弯半径是否符合交通流线的要求，有大型（大巴车）车辆通行集散要求的场所转弯及停靠是否符合要求。",

                            },
                            {
                                "name": "4. 道路、场地坡度设置合理便于车辆通行、与建筑外墙间距合理，各功能区域同达性好，如接驳消防设施、垃圾中转设施、化粪池、后勤卸货等功能区",

                            },
                            {
                                "name": "5. 功能分区合理，影响干扰小、尤其对于产生噪音、气味、光污染、热源的功能应尽量远离建筑或做遮挡。",

                            },
                            {
                                "name": "6. 道路、场地竖向标高与建筑正负零标高衔接高差处理是否合理，是否考虑无障碍通行需求",

                            }
                        ]
                    },
                    {
                        "name": "地下车库排风口",
                        "children": [
                            {
                                "name": "1. 出地面风井应结合建筑山墙布置，紧邻地上建筑设置、不应布置在主要视线范围内，应设置栅栏等装饰优化视觉效果。",

                            },
                            {
                                "name": "2. 行车出入口满足视线三角，车型流线及功能入口分区管理接驳主干道的车型出入口应设缓行区",

                            },
                            {
                                "name": "3. 地下室出地面的送排风口除与建筑距离满足规范要求外，还应考虑视线遮挡、美观、噪音影响。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "退界/退线合规",
                        "children": [
                            {
                                "name": "1.建筑物及附属设施不得突出道路红线、用地红线或建筑控制线。",

                            },
                            {
                                "name": "2.建筑外轮廓、定位、竖向标高与规划方案、报规文本，地下室单体轮廓一致。",

                            }
                        ]
                    },
                    {
                        "name": "道路等级与宽度",
                        "children": [
                            {
                                "name": "1.消防车道宽度，转弯半径、高度应满足规范。消防扑救场地尺寸、位置、回车场大小满足规范。",

                            },
                            {
                                "name": "2.道路距建筑外墙距离满足规范。",

                            }
                        ]
                    },
                    {
                        "name": "地下车库出入口",
                        "children": [
                            {
                                "name": "1. 地下室出入口起坡点与道路红线、道路边缘的距离满足规范。",

                            },
                            {
                                "name": "2. 地下室出入口起、末端均设有截水沟，当露天车道长度超过5米时，设置中间截水沟。",

                            }
                        ]
                    },
                    {
                        "name": "退界/间距",
                        "children": [
                            {
                                "name": "1. 总平面图平面布置是否合理，建筑物与管线、构筑物、绿化植栽以及其他建筑物之间的距离是否满足规范要求标高是否正确。",

                            }
                        ]
                    },
                    {
                        "name": "技术经济指标",
                        "children": [
                            {
                                "name": "1. 地上、地下部分机动车、非机动车停车位数量、充个电车位数量等应与图纸一致，绿地率计算、折算统计应按规则与指标一致、日照符合规范要求",

                            },
                            {
                                "name": "2. 总平技术经济指标应与单体统计一致（重要），尤其计容面积、配套面积、容积率、绿地率、建筑密度、停车位数量、人防面积等。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "平面布置",
                "children": [
                    {
                        "name": "错漏碰缺",
                        "children": [
                            {
                                "name": "1. 消防取水口，消防水箱在总图上需表达。",

                            },
                            {
                                "name": "2. 场地楼梯，电梯设计无遗漏。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "建筑专业-地下室",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "停车位",
                        "children": [
                            {
                                "name": "1. 框架柱、消火栓、设备箱体、分割墙、人防门应满足车门开启和车位净宽度要求 。",

                            },
                            {
                                "name": "2. 地下室柱网布置不能影响车门开启，车位前端距离侧面的柱子后端不大于1.6米。",

                            }
                        ]
                    },
                    {
                        "name": "影响地下室层高的主要因素",
                        "children": [
                            {
                                "name": "1. 地下室层高应考虑：结构高度、通风管高度、喷淋头高度、车位净高、地面及耐磨层（含找坡）高度。",

                            },
                            {
                                "name": "2.设备管线层高度:(人防需排烟/风管/喷林的)不超过650mm，条件允许时应尽量控制在550mm",

                            }
                        ]
                    },
                    {
                        "name": "地库出入口坡道防水",
                        "children": [
                            {
                                "name": "1. 车道出入口两侧挡墙应采取与地下室侧壁相同的防排水措施，避免环境水渗入车道范围。",

                            },
                            {
                                "name": "2. 地下室出入口坡道入口处应设反坡以防雨水倒灌。",

                            },
                            {
                                "name": "3.出入口坡道四周应设置反坎以防雨水倒灌。",

                            },
                            {
                                "name": "4.出入口坡道入口处及结束处应设置截水沟。",

                            },
                            {
                                "name": "5. 车库出入口侧墙应采取贴面砖等措施防反碱、起泡、脱层，并与整体风格协调。",

                            }
                        ]
                    },
                    {
                        "name": "地下室排水",
                        "children": [
                            {
                                "name": "1. 集水坑优先设置于非车位、非车道处，不应设置在人行通道、电梯厅内。",

                            }
                        ]
                    },
                    {
                        "name": "地库出入口",
                        "children": [
                            {
                                "name": "1. 地下入口及室内净高不应低于2400，入口有高差时应增设无障碍坡道。",

                            }
                        ]
                    },
                    {
                        "name": "地下室楼梯",
                        "children": [
                            {
                                "name": "1.  出地面的楼梯要考虑数量最少并与园林结合。",

                            },
                            {
                                "name": "2.楼梯需考虑安全栏杆。",

                            }
                        ]
                    },
                    {
                        "name": "其他",
                        "children": [
                            {
                                "name": "1. 所有设备房不跨越结构缝。",

                            },
                            {
                                "name": "2. 发电机房应涉及明沟排水，且发电机房上部房间不应为涉水房间，且地面应设防水层 。",

                            },
                            {
                                "name": "3. 水表房应设排水地漏和门槛 。",

                            },
                            {
                                "name": "4. 汽车坡道出入口处应设防火卷帘。",

                            },
                            {
                                "name": "5. 地下配电房沟底标高严禁低于排水标高，存在积水情况 。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "防火门等级",
                        "children": [
                            {
                                "name": "1. 防火门、窗等级应按照规范要求，不得高于规范等级，造成成本浪费。",

                            }
                        ]
                    },
                    {
                        "name": "设备房位置",
                        "children": [
                            {
                                "name": "1. 设备用房应布置在利用率较底的位置，不得占用最优位置停车位，造成车位数量减少 。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "经济技术指标",
                        "children": [
                            {
                                "name": "1. 建筑经济技术指标（初设、施工图、竣工）",

                            }
                        ]
                    },
                    {
                        "name": "设置充电车区域",
                        "children": [
                            {
                                "name": "1. 如有“一次性配建”的充电停车区，需反映出位置，不应设置在地势低洼易产生积水的位置；不应设置在有剧烈振动或高温的场所。",

                            }
                        ]
                    },
                    {
                        "name": "电梯基坑排水",
                        "children": [
                            {
                                "name": "1. 所有电梯均应设置防、排水措施（食梯除外）。设置排水管及集水坑，且该集水坑不应接纳电梯基坑外的其它排水，严禁电梯基坑与雨水排水集水坑合用。",

                            }
                        ]
                    },
                    {
                        "name": "疏散通道宽度",
                        "children": [
                            {
                                "name": "1. 与地下室车库相连通的单元入口应设置为钢制防火门 ，且停车位处满足1.2m疏散宽度。",

                            }
                        ]
                    },
                    {
                        "name": "防坠措施",
                        "children": [
                            {
                                "name": "1. 通往车库的出入口和坡道上方应有防坠落物的设施 。",

                            }
                        ]
                    },
                    {
                        "name": "斜板停车坡度",
                        "children": [
                            {
                                "name": "1. 斜板停车时，车行道（停车区）坡度应≤5%。",

                            }
                        ]
                    },
                    {
                        "name": "新技术运用",
                        "children": [
                            {
                                "name": "1. 新材料、新技术的运用是否合理，建筑造型、构造的作法是否完整、可行、合理。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 地下室顶板图应表达排水坡度和坡向以及各处不同标高。",

                            },
                            {
                                "name": "2. 剪力墙、人防墙的预留洞口及套管图纸应清晰完整，人防施工一次成型不允许后开洞口。狭窄通道的走管应合理排布，避免影响高度",

                            }
                        ]
                    },
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 地下室竖向构件必须与结构专业一致，避免因竖向构件不一致带来的如车位尺寸受损等问题。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "建筑专业-单体",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 结构竖向构件不得严重影响建筑内部使用功能。",

                            },
                            {
                                "name": "2. 室外电梯（楼梯）、结构竖向构件、廊柱、造型、出风口、风井等不得设置在人流动线上。",

                            }
                        ]
                    },
                    {
                        "name": "门洞反坎",
                        "children": [
                            {
                                "name": "1. 所有露台、屋面上外墙、女儿墙、出屋面风道、出地下室顶板建筑物（风井、楼梯间等）均设置砼反坎，反坎高度不小于400mm（厚度同墙体）；楼梯间出屋面门下方也应采用砼反坎。所有屋面反坎均应与主体一次性浇筑（砼强度同楼板）。",

                            }
                        ]
                    },
                    {
                        "name": "栏杆反坎",
                        "children": [
                            {
                                "name": "1. 栏杆大样应标注反坎宽度，以此判断是否为可踏面，阳台反坎宽度原则上按120设计。",

                            }
                        ]
                    },
                    {
                        "name": "栏杆安全",
                        "children": [
                            {
                                "name": "1. 大于3.6米-4米的栏杆需标注尺寸并注明加强构造做法。",

                            }
                        ]
                    },
                    {
                        "name": "门窗安装",
                        "children": [
                            {
                                "name": "1. 所有门必须设门垛；当门垛不易砌筑时，可设构造柱或与主体结构一次浇筑成型。",

                            }
                        ]
                    },
                    {
                        "name": "立面效果",
                        "children": [
                            {
                                "name": "1. 屋面排水管，雨棚排水管等立管应集中布置在隐蔽处，并与外墙同色。",

                            }
                        ]
                    },
                    {
                        "name": "净高控制",
                        "children": [
                            {
                                "name": "1. 建筑平面图的轴线、尺寸标注是否正确，建筑物层高、净高是否能满足要求",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "门窗安装",
                        "children": [
                            {
                                "name": "1. 防火门、窗等级不应高于规范要求，造成成本浪费。",

                            },
                            {
                                "name": "2. 门窗的选型、高度、开启方式、分隔方式是否合理，是否满足通风、安全要求。审查门窗的材质、色彩是否和立面效果协调。",

                            }
                        ]
                    },
                    {
                        "name": "墙体砌筑",
                        "children": [
                            {
                                "name": "1. 墙体厚度对设备布线、安装无影响且满足防火规范时，应做100厚。",

                            }
                        ]
                    },
                    {
                        "name": "施工合理性",
                        "children": [
                            {
                                "name": "1. 墙身大样做法中，不应有结构模板无法取出的结构空腔情形。",

                            }
                        ]
                    },
                    {
                        "name": "材料选用",
                        "children": [
                            {
                                "name": "1. 外装饰材料的经济性、采购的便捷性、施工可行性。",

                            }
                        ]
                    },
                    {
                        "name": "空调机位",
                        "children": [
                            {
                                "name": "1. 外立面线条设计是否理，外墙空调机位的设置是否合理、便于安装。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "疏散宽度",
                        "children": [
                            {
                                "name": "1. 结构构件或其他构筑物、景观、装饰品不得影响檐廊（通道）有效通行宽度。",

                            }
                        ]
                    },
                    {
                        "name": "楼梯净高与净宽",
                        "children": [
                            {
                                "name": "1. 楼梯平台上部及下部的净高（从最低处即平台梁底计算）不应小于2m；梯段净高不应小于2.2m。当净高较小时为确保不碰头，梯段踏步的起步位置，应从平台梁边后退一梯步宽度或300。楼梯平台扶手处的最小宽度不应小于梯段宽度。",

                            }
                        ]
                    },
                    {
                        "name": "栏杆高度",
                        "children": [
                            {
                                "name": "1. 各类建筑的阳台、外廊、室内回廊、内天井、上人屋面及室外楼梯等临空处的栏杆应用坚固耐久的材料做，栏杆的高度不应小于1.05m，高层建筑应适当增加，但不宜超过1.2m。有儿童活动的场所，栏杆应采用不易攀登的构造作法。住宅楼梯的栏杆扶手高度不应小于0.90m，水平段栏杆长度大于0.50m时，其高度不应小于1.05m，且栏杆垂直杆件间的净空不应大于0.11。栏杆高度计算，应从下部可踏部位起计算。",

                            }
                        ]
                    },
                    {
                        "name": "窗台高度",
                        "children": [
                            {
                                "name": "1. 窗台低于0.80m时应采取防护措施。外窗窗台距楼、地面的净高低于0.90m时，应设防护设施。窗台的净高或防护栏杆的高度均应从可踏面起算，保证净高0.9m。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 建筑施工图应包含所有构造柱的定位及配筋要求。",

                            },
                            {
                                "name": "2. 门窗大样图中应对窗的开启方向明确表示。",

                            },
                            {
                                "name": "3. 所有屋面水箱及风机需要在建筑图纸定位，并给出基础具体的做法。",

                            },
                            {
                                "name": "4. 所有楼梯应有平面图与剖面图且与结构构件尺寸吻合，定位尺寸、标高、步高、步宽表达完善。",

                            },
                            {
                                "name": "5. 楼梯间开窗应设在休息平台处；不应与梯梁和梯柱冲突；",

                            },
                            {
                                "name": "6. 楼地面留洞均应有定位及洞口尺寸，所有洞口均应考虑防火，防水，排水处理。",

                            },
                            {
                                "name": "7. 每层平面均应有独立图层下的面积计算用闭合多段线，面积计算规则符合项目所在地政府要求。",

                            },
                            {
                                "name": "8. 有电梯剖面图（表达机房层，基坑），层门立面图，应根据电梯品牌表示出楼层指示器预留孔及召唤箱预留位置。",

                            },
                            {
                                "name": "9. 电梯预留门洞宽度、高度应根据建筑装饰构造做法按实际考虑。",

                            },
                            {
                                "name": "10. 立面图中材质图列，色号表达完整。",

                            },
                            {
                                "name": "11. 地下室需门窗统计",

                            },
                            {
                                "name": "12. 地下室内电梯前室，所有房间需表示面积，标高变化的房间需注明标高。",

                            }
                        ]
                    },
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 门窗分格方式、栏杆做法与样板房一致。",

                            },
                            {
                                "name": "2. 所有装饰构架、非永久性构件应进行文字标注；装饰百页应同门窗百页一起进行编号、不得遗漏。",

                            },
                            {
                                "name": "3. 消火栓位置在平面表达，设置合理，与标准一致。",

                            },
                            {
                                "name": "4. 平面、立面、剖面、与建筑节点保持一致。",

                            },
                            {
                                "name": "5. 平面不同部位标高、房间面积应标注完整。",

                            },
                            {
                                "name": "6. 标高系统，各功能房间之间的标高关系，降板是否正确。",

                            }
                        ]
                    },
                    {
                        "name": "电梯参数",
                        "children": [
                            {
                                "name": "1. 电梯井道尺寸应根据分配品牌进行设置，可大于电梯（最小）安装尺寸30-50mm；电梯底部、顶部缓冲高度满足电梯安装要求。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "建筑专业-精装",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "栏杆安全",
                        "children": [
                            {
                                "name": "1. 栏杆下部基座高度不宜小于200mm，避免装修铺贴后踢脚线高度高出基座而影响收口及效果。",

                            }
                        ]
                    },
                    {
                        "name": "门窗安装",
                        "children": [
                            {
                                "name": "1. 门洞及门窗的安装完成标高必须严格按装修完成参考标高进行预留，尤其是铝合金门和户内门安装标高；确保装修后不影响开启使用和美观效果。",

                            },
                            {
                                "name": "2. 所有墙体定位与厚度，应考虑到天花梁位及空间的实际布局，如房间门垛有条件时要保证100mm,最少50mm；确保装修门套安装完成后满足门洞净空使用要求。",

                            },
                            {
                                "name": "3. 防火门安装位置不能影响精装收口 。",

                            },
                            {
                                "name": "4. 电梯门洞墙体是否满足干挂石材要求。",

                            }
                        ]
                    },
                    {
                        "name": "设备留洞",
                        "children": [
                            {
                                "name": "1. 空调冷媒管孔洞设置位置尽量不要影响室内衣柜或书柜等柜体的摆放。",

                            }
                        ]
                    },
                    {
                        "name": "净高控制",
                        "children": [
                            {
                                "name": "1. 换气扇管道预留孔洞是否影响装修吊顶高度。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "建筑专业-景观",
        "children": [
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 施工图阶段局部景观车道转曲线时荷载要满足消防功能；登高面、回车场不影响景观大的节点。",

                            },
                            {
                                "name": "2. 出入口岗亭设置需满足消防车道宽度，消防车道报建时需与景观确认。",

                            }
                        ]
                    },
                    {
                        "name": "道路坡度",
                        "children": [
                            {
                                "name": "1. 道路标高与建筑交接的关系，道路坡度是否合理。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "结构专业-地下室",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 结构构件不得严重影响建筑外立面效果。",

                            },
                            {
                                "name": "2. 竖向构件不得严重影响建筑内部使用功能，且满足建筑门窗洞口尺寸要求。",

                            },
                            {
                                "name": "3. 梁高应满足满足建筑或装修净空要求，不应影响建筑门、窗安装。",

                            },
                            {
                                "name": "4. 反梁的设计不得影响上部房间（平台）的使用，顶板反梁应设计有排水孔洞。",

                            },
                            {
                                "name": "5. 所有楼梯应有平面图与剖面图，梯柱位置不得影响门窗洞口、风井洞口或通道宽度，楼梯起步梁和平台梁高度应满足建筑净高要求。",

                            }
                        ]
                    },
                    {
                        "name": "净高控制",
                        "children": [
                            {
                                "name": "1. 考虑设备管线后，车道出入口净高不低于2400mm。",

                            },
                            {
                                "name": "2. 结构构件通过管井空间时应满足管井净尺寸要求、不影响排水、排风要求。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "构造要求",
                        "children": [
                            {
                                "name": "1. 采用桩基础时，按桩身和基桩控制的承载力与桩基承受荷载相匹配。",

                            },
                            {
                                "name": "2. 当独立基础的边长或条形基础的宽度≥2.5m时，需注明底板受力钢筋的长度可取边长或宽度的0.9倍并交错布置，防止造成成本浪费",

                            }
                        ]
                    },
                    {
                        "name": "其他",
                        "children": [
                            {
                                "name": "1. 根据场地条件地下室顶板宜选用结构找坡。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 不得出现计算模型与施工图不一致导致结构受力情况出现较大变化",

                            }
                        ]
                    },
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 地下室底板、挡墙、顶板各构件的抗渗等级不得低于P8（区域属地化标准评审通过后可调整）。",

                            }
                        ]
                    },
                    {
                        "name": "超长措施",
                        "children": [
                            {
                                "name": "1. 超长地下室（150m及以上）应采取设后浇带、添加膨胀剂等至少2种以上的抗裂措施，具体措施符合企业技术标准，后浇带布置应合理。",

                            }
                        ]
                    },
                    {
                        "name": "构造要求",
                        "children": [
                            {
                                "name": "1. 出地面楼梯间的混凝土反坎应高于室外地坪300mm以上。",

                            },
                            {
                                "name": "2. 梯柱、底层楼梯起步处设置条基或基础梁。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 基础图应包含地下车库和主楼的拼接平面图，需检查基础的碰撞和标高关系；车库、塔楼、裙楼交界处等须准确反映相邻基础平面、集水井定位，与首层竖向构件关系表达清晰。",

                            },
                            {
                                "name": "2. 基础底板、筏板等变厚度和高差处等特殊部位应绘制详图。",

                            },
                            {
                                "name": "3. 应明确注明沉降后浇带或收缩后浇带，后浇带应避开人防口部、临战封堵框，应尽量避开重要设备房。",

                            },
                            {
                                "name": "4. 地下室平面布置图中应准确表示出人防区域的范围，避免图纸矛盾。",

                            },
                            {
                                "name": "5. 地下室墙及柱截面、定位标注、顶标高表达满足出图深度要求。",

                            },
                            {
                                "name": "6. 地下室梁截面、定位标注、面标高、跨数表达满足出图深度要求。",

                            },
                            {
                                "name": "7. 地下室顶板及楼板截面、定位标注、面标高表达满足出图深度要求且与建筑图一致。",

                            },
                            {
                                "name": "8. 结构留洞表达准确（梁上任意边≥100mm的洞口、墙上任意边大于250的洞口（不小于100的预埋套管）、楼板上短边不小于300mm的洞需绘出），不得遗漏消防吸水孔、水池检修孔。",

                            }
                        ]
                    },
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 集水坑井及盲沟的数量、尺寸、标高与建筑相符。",

                            },
                            {
                                "name": "2. 电梯基坑排水套管、水池、地沟、设备基础的定位、标高等符合建筑要求。",

                            },
                            {
                                "name": "3. 扶梯基坑位置、标高与建筑应保持一致。",

                            },
                            {
                                "name": "4. 基础截面、材料强度、类型、编号、定位标注、截面尺寸标注、顶标高、定位尺寸满足规范计算要求，与节点大样对应并符合建筑及设备要求 。",

                            }
                        ]
                    },
                    {
                        "name": "构造要求",
                        "children": [
                            {
                                "name": "1. 降板处板底在梁高范围内或加吊板满足支座要求。",

                            },
                            {
                                "name": "2. 车库顶板临空边缘、洞口周边、高差处应有挡土板布置图。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "结构专业-单体",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "平面布置",

                    },
                    {
                        "name": "净高要求",

                    }
                ]
            },
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "构造要求",

                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "构造要求",
                        "children": [
                            {
                                "name": "1. 应尽量避免出现短柱（楼梯间除外，短柱箍筋需全高加密）情况，不应出现极短柱。",

                            },
                            {
                                "name": "2. 荷载传力途径应直接，主次梁之间的搭接传力路径不超过3次。",

                            },
                            {
                                "name": "3. 剪力墙、柱收截面宽度，应保证外部平齐。",

                            },
                            {
                                "name": "4. 电梯前室范围内不应露梁。",

                            },
                            {
                                "name": "5. 电梯井道砌体墙部位应按电梯资料预留安装用暗梁。",

                            },
                            {
                                "name": "6. 通电梯井道如需分割时，采用钢筋混凝土与主体结构整体浇筑。",

                            }
                        ]
                    },
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 建筑外墙节点必须以墙身大样方式进行绘制，结构与之对应。",

                            }
                        ]
                    },
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 地下室底板、挡墙、顶板各构件的抗渗等级不得低于P8（区域属地化标准评审通过后可调整）。 ",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 结构层高、层数、平立剖面命名规则必须完全一致与建筑匹配。",

                            },
                            {
                                "name": "2. 建施、结施及模型中关于材料类型、材料使用位置等应一致。容重取值应与计算一致；应与实际相符。",

                            },
                            {
                                "name": "3. 车库、塔楼、裙楼交界处基础表达一致，与首层竖向构件关系表达清晰。",

                            },
                            {
                                "name": "4. 基础截面、材料强度、类型、编号、定位标注、截面尺寸标注、顶标高、定位尺寸满足规范计算要求，与节点大样对应并符合建筑及设备要求",

                            },
                            {
                                "name": "5. 基础底板、筏板等变厚度和高差处等特殊部位应绘制。",

                            },
                            {
                                "name": "6. 集水坑井及盲沟的数量、尺寸、标高与建筑相符。",

                            },
                            {
                                "name": "7. 电梯基坑排水套管、水池、地沟、设备基础的定位、标高等符合建筑要求。",

                            },
                            {
                                "name": "8. 墙柱截面、材料强度、类型、编号、定位标注、顶标高满足规范计算要求，与节点大样对应并符合建筑及设备要求。",

                            },
                            {
                                "name": "9. 电梯召唤盒、消火栓箱等设备箱体处宜避开剪力墙，无法避免时应预留，并考虑削弱的影响。",

                            },
                            {
                                "name": "10. 楼板截面、定位标注、面标高表达满足出图深度要求。",

                            },
                            {
                                "name": "11. 无机房电梯及预留的电梯井道，须预留电梯荷载。",

                            },
                            {
                                "name": "12. 完整空间顶板应保证标高相同。",

                            },
                            {
                                "name": "13. 坡屋面及复杂屋面各主要坡向均有剖面图示，且与建筑设计一致。",

                            },
                            {
                                "name": "14. 结构留洞表达准确（梁上任意边≥100mm的洞口、墙上任意边大于250的洞口（不小于100的预埋套管）、楼板上短边不小于300mm的洞需绘出），不得遗漏消防吸水孔、水池检修孔。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "给排水专业-总图",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 总水表井、隔油池、化粪池（生化池、格栅池）位置不在园区出入口、主要人流动线上、公共活动场地附近,业主花园、单元入口、车库入口处道路上、洋房花园入口、门窗洞口附近及商业门口应无检查井盖。隔油池、化粪池应设置通气管 ",

                            },
                            {
                                "name": "2. 室外管网需与景观图纸进行合图，严禁出现阴阳井，避免消火栓、水泵结合器、格栅池在景观道路上。",

                            },
                            {
                                "name": "3. 合理设置截水沟、雨水篦子（园区与市政接驳道路入口处、场地低洼处等位置宜设置截水沟）。以防止场地内涝及场地积水 。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "经济合理",
                        "children": [
                            {
                                "name": "1. 控制检查井数量及管网埋深 ",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 园区给水管网设置错误，整体性用水安全存在严重隐患。（如给水管网与中水、回用雨水管网连接。）",

                            },
                            {
                                "name": "2. 排水出户管顶标高不应低于总平排水干管接口井排水管顶标高(特别关注排水系统起坡点楼栋)。",

                            },
                            {
                                "name": "3. 排水（单体及地下室、总平截水沟）出户管应在总图上接入检查井。",

                            },
                            {
                                "name": "4. 重力排水管道不得倒坡敷设。",

                            },
                            {
                                "name": "5. 雨水排水集水坑内排水泵设置不得少于两台，分水位依次启动并应考虑双泵能同时工作，且应提供不间断动力供应。",

                            },
                            {
                                "name": "6. 地下室顶板覆土深度，应满足室外排水干管坡度≥0.3%的要求。",

                            },
                            {
                                "name": "7. 尺寸错漏、标高错漏、文字错漏重叠等问题。",

                            }
                        ]
                    },
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 总图应表达屋顶消防稳压水箱、消防水池所在楼栋位置，并应表达消防水池取水口、消防水箱、消防水池有效容积。",

                            },
                            {
                                "name": "2. 检查井及构筑物应定位，若无法直接定位的检查井应采用坐标定位。",

                            },
                            {
                                "name": "3. 检查井及构筑物的高程应明确标注。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 给排水专业平面底图应与建筑平面图及相关专业图纸信息一致。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "给排水专业-地下室",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 管线应满足净高需求，有条件尽高安装。",

                            },
                            {
                                "name": "2. 给排水机房布置应综合考虑位置，并不宜与其他设备房集中布置。",

                            },
                            {
                                "name": "3. 下沉庭院的雨水需统一收集后接至地下公共集水井。",

                            },
                            {
                                "name": "4. 车库集水坑严禁设置在车道区域；无特殊条件限制时，集水坑不应布置在车位区域。",

                            },
                            {
                                "name": "5. 车库消火栓及支管布置不得影响汽车行驶和停车及主驾驶开门，支管不应设置于停车位一侧（消火栓及支管不得进入停车位及车道投影范围）。",

                            },
                            {
                                "name": "6. 消火栓箱不应正对电梯入口，消防立管及明装消火栓箱不应影响消防前室净尺寸要求并不得影响建筑疏散通道。",

                            },
                            {
                                "name": "7. 给排水立管及支管、消防立管及支管、消火栓等不得与墙面预留孔洞、开启的门窗、风口等相互交叉相挡。",

                            }
                        ]
                    },
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 污水集水坑及地下检查井井盖须采用密闭型井盖，并设通气管引至室外高位排放。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "经济合理",
                        "children": [
                            {
                                "name": "1. 消火栓设置过密，导致成本浪费。",

                            },
                            {
                                "name": "2. 阀门及组件设置过多、导致成本浪费。",

                            },
                            {
                                "name": "3. 系统分区、设备选型、管材选型不经济,导致成本浪费。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 给水管严禁穿越消防控制室、变配电房、强弱电房、发电机房、电梯机房、电井及风井(给发电机房预留的给水支管除外)。",

                            },
                            {
                                "name": "2. 给水管道在吊顶内明敷、地下室主要人行通道上方且存在结露风险时，应采取防结露措施。",

                            },
                            {
                                "name": "3. 雨水排水集水坑内排水泵设置不得少于两台，分水位依次启动并应考虑双泵能同时工作，且应提供不间断动力供应。",

                            },
                            {
                                "name": "4. 是否存在消火栓未能保护的地方。",

                            },
                            {
                                "name": "5. 地下车库管线下最不利位置高度应大于2.2米且避开车道范围。",

                            },
                            {
                                "name": "6. 排水管不得穿越消防控制室、变配电房、强弱电房、发电机房、生活水箱间、生活水泵房、电井及风井。",

                            },
                            {
                                "name": "7. 消火栓箱不应影响疏散过道宽度且箱体开门不小于120°。",

                            },
                            {
                                "name": "8. 变配电室电缆沟应设置排水措施，其中排水管不能直接接入集水坑（在易出现洪涝风险的城市及项目，应设置单独集水坑及排水泵且排水泵应间接排水避免排水泵出水管上止回阀损坏导致总图雨水倒灌回配电房）。(当集水坑在变配电室下层时,可与其它排水共用)。",

                            }
                        ]
                    },
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 所有电梯基坑（除厨房食梯以外的）含消防电梯、普通电梯、观光电梯、自动扶梯等公共电梯均应有排水措施,多台相邻电梯基坑可合用一个集水坑。",

                            },
                            {
                                "name": "2. 穿地下室（水池）顶板及侧壁的管道应定位准确。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 地下室出入口起、末端均设有截水沟，当露天车道长度超过5米时，设置中间截水沟。入口处应做建筑反坡，入口起端截水沟排水可接至总图雨水口或检查井，末端截水沟排水接至雨水集水坑。",

                            },
                            {
                                "name": "2. 室内设置泡沫罐的项目，泡沫罐应设置在专用房间内，且考虑排水措施。",

                            },
                            {
                                "name": "3. 地下车库设备管线布置应避开柱帽，车道范围不允许防排烟与其他大型管线交叉。",

                            },
                            {
                                "name": "4. 首层立管是否与结构端柱、剪力墙等冲突，首层出户管是否与结构地梁相撞。",

                            }
                        ]
                    },
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 尺寸错漏、标高错漏、文字错漏重叠等问题。",

                            },
                            {
                                "name": "2. 穿剪力墙、梁等的套管应根据穿越的不同情况分别标注采用的套管类型、材质、标高、管径、定位。",

                            }
                        ]
                    },
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 给排水专业平面底图应与建筑平面图及相关专业图纸信息一致。",

                            },
                            {
                                "name": "2. 消火栓位置及嵌入方式应与建筑图表达一致，嵌入剪力墙时复核结构专业图纸,设置与楼梯间侧壁的消火栓需与结构配合是否撞结构楼梯间梁。消火栓不得暗装于防火分区隔墙上 。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "给排水专业-单体",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 下沉庭院的雨水需统一收集后接至地下公共集水井。",

                            },
                            {
                                "name": "2. 公共区域消火栓宜暗装布置 ",

                            },
                            {
                                "name": "3. 消火栓箱不应正对电梯入口，消防立管及明装消火栓箱不应贴邻入户门垛（小于1米范围）设置（若条件限制不得不布置在对应位置，则需精装包裹处理）。",

                            },
                            {
                                "name": "4. 给排水立管及支管、消防立管及支管、消火栓等不得与墙面预留孔洞、开启的门窗、风口等相互交叉相挡。",

                            },
                            {
                                "name": "5. 消火栓有条件时应优先采用嵌入式（或半嵌入）便于装修，尽可能同建筑专业协调加厚墙体采用全嵌入式。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "经济合理",
                        "children": [
                            {
                                "name": "1. 阀门及组件设置过多、导致成本浪费。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 给排水管严禁穿越消防控制室、变配电房、强弱电房、发电机房、电梯机房、电井及风井(给发电机房预留的给水支管除外)。",

                            },
                            {
                                "name": "2. 给水管道在吊顶内明敷、地下室主要人行通道上方且存在结露风险时，应采取防结露措施。",

                            },
                            {
                                "name": "3. 雨水排水集水坑内排水泵设置不得少于两台，分水位依次启动并应考虑双泵能同时工作，且应提供不间断动力供应。",

                            },
                            {
                                "name": "4. 是否存在消火栓未能保护的地方。",

                            },
                            {
                                "name": "5. 排水立管不得安装在封闭空间内，如因建筑立面需要必须做封闭时应设置检修措施。",

                            },
                            {
                                "name": "6. 消火栓箱不应影响疏散过道宽度且箱体开门不小于120°。",

                            },
                            {
                                "name": "7. 有反梁的屋面、露台、地下室顶板等部位应在梁上设计连通管或过水孔，避免形成积水。",

                            },
                            {
                                "name": "8. 学生食堂、餐厅、厨房区域上方不得有排水管线穿越 ",

                            },
                            {
                                "name": "9. 三级及三级以上生物安全实验室除应在设备连接管上设倒流防止器外还应在引入管上设置有空气间隙的水箱，设置位置应在防护区外 ",

                            },
                            {
                                "name": "10. 屋顶（含三层以上坡屋面）、露台、阳台均为有组织排水。主屋面排水应单独排出室外，所有雨水、冷凝水排水除地方政策规定外，不得直接散排至建筑周边地面，需接入雨水口或散水沟内。",

                            },
                            {
                                "name": "11. 空调板、阳台、露台及设备平台地漏宜设置在外侧，避免地漏设置在墙根部位。当空调板为双层时,每层钢筋混凝土板上均应设置地漏。",

                            },
                            {
                                "name": "12. 与外廊或室外相邻的电梯厅必须设置地面高差或隔离排水沟，排水接至室外雨水井。",

                            }
                        ]
                    },
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 所有电梯基坑（除别墅户内电梯以外的）含消防电梯、普通电梯、观光电梯、自动扶梯等公共电梯均应有排水措施,多台相邻电梯基坑可合用一个集水坑但电梯专用积水坑内不得有其余排水管接入。",

                            },
                            {
                                "name": "2. 屋面若有相关横管贴屋面敷设，相关管道不得靠建筑外墙（屋面管线距外墙距离不小于1.5m），走管路由不得影响建筑屋面疏散通道 。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 尺寸错漏、标高错漏、文字错漏重叠等问题。",

                            },
                            {
                                "name": "2. 穿剪力墙、梁等的套管应根据穿越的不同情况分别标注采用的套管类型、材质、标高、管径、定位。",

                            }
                        ]
                    },
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 给排水专业平面底图应与建筑平面图及相关专业图纸信息一致。",

                            },
                            {
                                "name": "2. 消火栓位置及嵌入方式应与建筑图表达一致，嵌入剪力墙时复核结构专业图纸,设置与楼梯间侧壁的消火栓需与结构配合是否撞结构楼梯间梁。",

                            }
                        ]
                    },
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 首层立管是否与结构端柱、剪力墙等冲突，首层出户管是否与结构地梁相撞。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "暖通专业-总图",
        "children": [
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "经济合理",
                        "children": [
                            {
                                "name": "1. 园区热力管网主干线力求线路短直，施工方便、维修简便。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 锅炉房及换热机房，应设置供热量控制装置。集中采暖系统中建筑物的热力入口处，必须设置楼前热量表。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 暖通专业平面底图应与建筑平面图及相关专业图纸信息一致。",

                            }
                        ]
                    },
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 热力检查井及构筑物应定位，若无法直接定位的检查井应采用坐标定位。",

                            },
                            {
                                "name": "2. 热力检查井及构筑物的高程应明确标注。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "暖通专业-地下室",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "系统要求",
                        "children": [
                            {
                                "name": "1. 柴油发电机房应设计足够的送、排风井面积，并保证足够的有效消声长度。",

                            },
                            {
                                "name": "2. 合用井道的风机出口必须设置止回阀 。",

                            }
                        ]
                    },
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 室内消防加压风口设置位置不得与开启的门、消火栓、立管遮挡 。",

                            }
                        ]
                    },
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 送排风井不得与建筑结构梁冲突，而影响风井有效截面积。 ",

                            }
                        ]
                    },
                    {
                        "name": "净高控制",
                        "children": [
                            {
                                "name": "1. 地下车库施工图设计提供管线综合图，管线下最不利位置高度应大于2.2米且避开车道范围。地下车库设备管线布置应避开柱帽，车道范围不允许防排烟与其他大型管线交叉。",

                            }
                        ]
                    },
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 风管穿越防火隔墙处防火阀设置核查，尤其穿越楼板处防火阀是否设置。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 风机选型、风机房及风井尺寸、风口/风阀形式及尺寸等设置不合理，导致成本浪费。 ",

                            }
                        ]
                    },
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 加压送风、排烟风机和用于排烟补风的送风机两侧应有大于600mm的检修空间",

                            }
                        ]
                    },
                    {
                        "name": "经济合理",
                        "children": [
                            {
                                "name": "1. 地下一层车库有直通室外的出入口的防火分区，当车道出入口未设置防火卷帘时，应采用自然补风。 ",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 供暖管道是否避免穿越建筑的一些特殊部位（如：变配电室、电梯机房、通信机房等）。 ",

                            }
                        ]
                    },
                    {
                        "name": "系统要求",
                        "children": [
                            {
                                "name": "1. 柴发机房和储油间的排风系统应分别独立设置，且应采用防爆风机。",

                            },
                            {
                                "name": "2. 柴发电机排烟道需设置在专用排烟井内，并采用金属烟道加隔热措施引至屋面排放。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 暖通专业平面底图应与建筑平面图及相关专业图纸信息一致。 ",

                            },
                            {
                                "name": "2. 风管、空调水管、冷媒管等预留孔洞的尺寸应与建筑、结构专业一致。 ",

                            }
                        ]
                    },
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 设备编号、立管编号、管道走向、管径标注、立支管与干管的接管关系正确、水平干管标注标高，必须绘制楼层线并应标注标高和层数。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "暖通专业-单体",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "系统要求",
                        "children": [
                            {
                                "name": "1. 室内空调回风必须采用回风箱/回风管方式回风，严禁采用吊顶回风方式。 ",

                            }
                        ]
                    },
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 出地面的车库排风井、送风井（包括依附在建筑主体侧）等暖通方面的构筑物，不得设置在人流动线上,严禁影响立面以及遮挡。",

                            },
                            {
                                "name": "2. 防烟系统与消防补风系统的室外进风口与排烟系统的室外出风口布置应满足当地消防规范要求，无地标时应满足国标要求，进风口不应与进风口设在同一面上，当确有困难时，进风口应设置在排烟口的下方，两者边缘最小垂直距离不应小于6m；水平布置时，两者边缘最小水平距离不应小于20m ",

                            },
                            {
                                "name": "3. 空调送回风应选用上送上回或侧送上回，不宜得采用侧送侧回。",

                            },
                            {
                                "name": "4. 教室内空调送风口避免对人直吹，人员座位尽量位于回风区 ",

                            },
                            {
                                "name": "5. 地板辐射采暖系统分集水器位置设置合理，满足检修维护、泄水等要求，减少对装饰观感的影响。（若有） ",

                            },
                            {
                                "name": "6. 室内消防加压风口设置位置不得与开启的门、消火栓、立管遮挡 ",

                            },
                            {
                                "name": "7. 送排风井不得与建筑结构梁冲突，而影响风井有效截面积。 ",

                            },
                            {
                                "name": "8. 电梯机房排气扇需考虑距离外窗或门的位置，如距离太近造成气流组织不好。",

                            }
                        ]
                    },
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 电梯机房应有通风降温设施，通风窗应采取防雨防鼠措施，夏季气温较高区域需设置分体空调。 ",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 风机选型、风机房及风井尺寸、风口/风阀形式及尺寸等设置不合理，导致成本浪费。 ",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "系统要求",
                        "children": [
                            {
                                "name": "1. 餐饮排油烟不得采用土建井道排放，需采用镀锌钢板或不锈钢材质风道。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 暖通专业平面底图应与建筑平面图及相关专业图纸信息一致。",

                            }
                        ]
                    },
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 设备编号、立管编号、管道走向、管径标注、立支管与干管的接管关系正确、水平干管标注标高，必须绘制楼层线并应标注标高和层数。 ",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "强电专业-总图",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 强弱电检查井的位置应与景观协调一致 ",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 总图平面路由应该经济合理。",

                            },
                            {
                                "name": "2. 总图平面预埋管线数量规格经济合理。",

                            },
                            {
                                "name": "3. 总图平面预埋管线材质经济合理。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 室外箱体灯具要注明相应的防护措施。",

                            },
                            {
                                "name": "2. 桥架不应穿越楼梯间、空调机房、水管井、风井等。",

                            },
                            {
                                "name": "3. 进入地下室套管处的强弱电检查井要求必须采用现浇混凝土检查井，严禁采用砖砌检查井。",

                            }
                        ]
                    },
                    {
                        "name": "构造要求",
                        "children": [
                            {
                                "name": "1. 室外强弱电井应设排水措施，就近排入室外雨水井或地下室集水坑、排水沟。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "制图深度",
                        "children": [
                            {
                                "name": "1. 电气总图上应标注各个开闭所、变配电室、发电机房、弱电机房、消防控制室位置及其设备配置情况。",

                            },
                            {
                                "name": "2. 干线回路编号或回路导线标注完整、清晰 ",

                            },
                            {
                                "name": "3. 电气总图应明确强弱电市政接驳口位置、敷设方式。 ",

                            }
                        ]
                    },
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 电气最终平面底图与建筑平面图、相关设备专业设备位置等应保持一致。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "强电专业-地下室",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 变配电室和柴油发电机室严禁设置在变形缝处和宿舍/教室的正下方，并应不直接紧邻 ",

                            },
                            {
                                "name": "2. 柴油发电机尾气处理不达标造成的环境污染，柴油发电机房进排风井对环境的影响，未采取合理的处理措施。",

                            }
                        ]
                    },
                    {
                        "name": "净高要求",
                        "children": [
                            {
                                "name": "1. 地下车库施工图设计提供管线综合图，管线下最不利位置高度应大于2.2米且避开车道范围。地下车库设备管线布置应避开柱帽，车道范围不允许防排烟与其他大型管线交叉。",

                            }
                        ]
                    },
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 电梯开门正对面墙上尽量不设置电气设备。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "构造要求",
                        "children": [
                            {
                                "name": "1. 高低压系统设置应经济合理（包含进线数量、项目总装机容量、用电功率、配电方式、接地系统等）。",

                            }
                        ]
                    },
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 设备房（变配电房、柴油发电机房、消防控制室）面积、层高经济且符合要求 ",

                            },
                            {
                                "name": "2. 涉及到墙体、楼板内预埋的强、弱电元件，其点位和连线需在图中表示位置，避免未预留管线引起后期变更 ",

                            },
                            {
                                "name": "3. 变配电室严禁设在厕所、浴室、景观水池、游泳池或其他经常积水场所的正下方；且不宜与上述场所相贴邻，如果必须贴邻，相邻墙两侧必须做防渗漏、防结露等防水处理 ",

                            },
                            {
                                "name": "4. 应有变、配电所、柴油发电机房设备布置平面、立面、剖面图，满足施工图深度规定（或满足当地施工图审查及供电部门规定的深度要求） ",

                            },
                            {
                                "name": "5. 地下车库需预留电动汽车充电设施供电容量及相关设施安装位置。",

                            },
                            {
                                "name": "6. 在配电室预留总平景观照明专用回路，并预留穿墙套管。",

                            }
                        ]
                    },
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 火灾探测器、消防广播、手报按钮等消防元件保护半径距离应合理经济 ",

                            },
                            {
                                "name": "2. 电气元件（主要指断路器等）选型应合理，不可过度预留，增加造价； ",

                            },
                            {
                                "name": "3. 浪涌保护器应按照规范允许的最低标准设置，不过多设置。",

                            },
                            {
                                "name": "4. 电缆、电线应按照规范允许的最低标准选择规格，避免成本浪费； ",

                            },
                            {
                                "name": "5. 所有变配电室内，不应有与其无关的管道和线路通过 ",

                            },
                            {
                                "name": "6. 消防控制室内严禁穿过与消防设施无关的电气线路及管线。",

                            },
                            {
                                "name": "7. 消防系统能自动控制单元门开启、能自动控制停车场系统的道闸 ",

                            },
                            {
                                "name": "8. 消防电力设备的配电应满足规范要求。",

                            },
                            {
                                "name": "9. 在配电室预留总平景观照明专用回路、泛光照明回路 ",

                            },
                            {
                                "name": "10. 电梯机房、配电房、弱电机房、消防控制室等房间预留空调插座或在配电箱中明确预留电源。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 变配电室不宜设在地下室临外墙处，若受条件限制必须临外墙设置时，临外墙的进出线电缆穿墙套管严禁设在变配电室内，外墙的内外侧必须采取有效的防渗漏措施 ",

                            },
                            {
                                "name": "2. 强弱电进线预留孔洞位置及要求是否与结构、建筑图纸相符的要求，并避免机电专业内部碰撞 ",

                            },
                            {
                                "name": "3. 弱电机房及主要桥架路由、规格型号表达清楚。",

                            },
                            {
                                "name": "4. 车库内电气桥架是否有穿越防火卷帘的情况（正常情况下不允许穿越）。",

                            }
                        ]
                    },
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 电气最终平面底图与建筑平面图、相关设备专业设备位置等应保持一致。",

                            }
                        ]
                    },
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 消防系统主机、探测器、报警设备、控制模块、消防线缆等的选型及安装位置正确 ",

                            },
                            {
                                "name": "2. 如需设备自带控制箱（如潜污泵、生活消防水泵等）需与相关专业协调并在图纸中注明 ",

                            },
                            {
                                "name": "3. 应急照明灯具设计、连线应合理，疏散指示方向及安装位置无误。",

                            },
                            {
                                "name": "4. 电梯机房、配电房、弱电机房、消防控制室等房间预留空调插座或电源。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "强电专业-单体",
        "children": [
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 电梯开门正对面墙上尽量不设置电气设备。 ",

                            },
                            {
                                "name": "2. 涉及到墙体、楼板内预埋的强、弱电元件，其点位和连线需在图中表示位置，避免未预留管线引起后期变更 ",

                            },
                            {
                                "name": "3. 疏散楼梯间、电梯前室、合用前室、走道采用自带红外感应的吸顶灯具，或在吊顶区域设置筒灯，并在吊顶上设感应开关。",

                            }
                        ]
                    },
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 火灾探测器、消防广播、手报按钮等消防元件保护半径距离应合理经济 ",

                            },
                            {
                                "name": "2. 电气元件（主要指断路器等）选型应合理，不可过度预留，增加造价； ",

                            },
                            {
                                "name": "3. 电缆、电线应按照规范允许的最低标准选择规格，避免成本浪费； ",

                            },
                            {
                                "name": "4. 消防控制室内严禁穿过与消防设施无关的电气线路及管线。",

                            },
                            {
                                "name": "5. 电梯机房、配电房、弱电机房、消防控制室等房间预留空调插座或在配电箱中明确预留电源。",

                            }
                        ]
                    },
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 精装项目的机电点位应与精装修点位一致，户内插座、开关、弱电点位应结合家具电器布置并进行合理设计，避免与门的开启方向、流线矛盾；照明开关的设置应合理方便。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "净高要求",
                "children": [
                    {
                        "name": "1. 标准层净高是否足够，桥架是否需要穿梁。",

                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 电气最终平面底图与建筑平面图、相关设备专业设备位置等应保持一致",

                            }
                        ]
                    },
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 电气竖井大小满足设备布置要求；标注开孔尺寸、绘制设备布置平面大样。",

                            },
                            {
                                "name": "2. 桥架线槽路应设计合理，在变截面处需标明规格。地下室主干电缆在变电站起端、引上引下不同楼层、设备接入端的地方应标明回路号，保证每条主电缆有始有终。",

                            },
                            {
                                "name": "3. 消防系统主机、探测器、报警设备、控制模块、消防线缆等的选型及安装位置正确。",

                            }
                        ]
                    },
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 如需设备自带控制箱（如潜污泵、生活消防水泵等）需与相关专业协调并在图纸中注明 ",

                            },
                            {
                                "name": "2. 应急照明灯具设计、连线应合理，疏散指示方向及安装位置无误。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "智能化专业",
        "children": [
            {
                "name": "品质影响",
                "children": [
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 电气最终平面底图与建筑平面图应保持一致。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "成本控制",
                "children": [
                    {
                        "name": "构造要求",
                        "children": [
                            {
                                "name": "1. 室外强弱电井应设排水措施，就近排入室外雨水井或地下室集水坑、排水沟。",

                            }
                        ]
                    },
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 进入地下室套管处的强弱电检查井要求必须采用现浇混凝土检查井，严禁采用砖砌检查井。",

                            },
                            {
                                "name": "2. 管线材质及规格应经济合理。 ",

                            }
                        ]
                    },
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 弱电检查井的位置应与景观协调一致。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "平面布置",
                "children": [
                    {
                        "name": "1. 监控点位位置设置合理。 ",

                    },
                    {
                        "name": "2. 人行、车行闸机的安装位置合理。",

                    }
                ]
            },
            {
                "name": "规范风险",
                "children": [
                    {
                        "name": "平面布置",
                        "children": [
                            {
                                "name": "1. 消防控制室、弱电机房严禁设置在变形缝处，严禁设置在有水房间正下方。房间大小应合理经济，不应过小或过大，消防控制室内，消防设备与安防设备应有明显分界。 ",

                            },
                            {
                                "name": "2. 门禁设置的位置合理。",

                            },
                            {
                                "name": "3. 桥架线槽路应设计合理，设置在商铺内的桥架，应贴梁敷设，且靠近墙面敷设，以不影响空间使用为准。",

                            }
                        ]
                    },
                    {
                        "name": "规范要求",
                        "children": [
                            {
                                "name": "1. 地下室电梯前室及能进入楼栋的楼梯口应设置监控。",

                            },
                            {
                                "name": "2. 监控点位设置合理。",

                            },
                            {
                                "name": "3. ECM系统布线合理。",

                            },
                            {
                                "name": "4. 安防机房内，不应有与其无关的管道和线路通过。",

                            },
                            {
                                "name": "5. UPS应为监控、门禁、可视对讲、周界、车库管理系统以及消防控制室弱电设备提供电源。",

                            },
                            {
                                "name": "6. 消防控制室严禁设置在变形缝处。",

                            },
                            {
                                "name": "7. 项目人行通道应设置摆闸或翼闸，总坪及地下室进入楼栋主要通道的单元门应设置对讲及门禁、进入同一区域的侧门应设置门禁。",

                            },
                            {
                                "name": "8. 除两层通高的高层大堂外，所有在大堂顶部通过的设备管应靠墙 600mm以内及板底下400mm以内完成。",

                            }
                        ]
                    }
                ]
            },
            {
                "name": "错漏碰缺",
                "children": [
                    {
                        "name": "一致性",
                        "children": [
                            {
                                "name": "1. 强弱电进线预留孔洞位置及要求是否与结构、建筑图纸相符的要求，并避免机电专业内部碰撞。",

                            },
                            {
                                "name": "2. 精装项目的机电点位应与精装修点位一致，户内弱电应结合家具电器布置并进行合理设计，避免与门的开启方向、流线矛盾。",

                            }
                        ]
                    },
                    {
                        "name": "净高要求",
                        "children": [
                            {
                                "name": "1. 地下车库施工图设计提供管线综合图，管线下最不利位置高度应大于2.2米且避开车道范围。地下车库设备管线布置应避开柱帽，车道范围不允许防排烟与其他大型管线交叉。",

                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "name": "机电管线综合",
        "children": [
            {
                "name": "避让原则",
                "children": [
                    {
                        "name": "1. 管道距墙、柱以及管道之间的净间距是否小于100mm（应不小于100mm）。",

                    },
                    {
                        "name": "2. 保温风管、水管是否考虑保温空间（应考虑保温空间） ",

                    },
                    {
                        "name": "3. 管线是否挡门、窗或是否通过电机盘、配电盘、仪表盘上方。",

                    },
                    {
                        "name": "4. 支吊架空间，一般情况下除考虑支架尺寸外（一般为50mm），是否预留有≥50mm空间，以方便支吊架的安装。",

                    },
                    {
                        "name": "5. 风管、排管宽度≥1200mm时，应复核下方是否考虑100-150mm喷淋头安装空间。",

                    },
                    {
                        "name": "6. 进行压扁处理时要保证风管的风速和流量，复核宽高比最大是否超过6，且要与设计人员共同确认。",

                    },
                    {
                        "name": "7. 室内给水与排水管道平行敷设时，复核两管之间的最小净间距，是否小于500mm（不得小于500mm）。",

                    },
                    {
                        "name": "8. 交叉铺设时，垂直净距是否小于150mm（不得小于150mm） ",

                    },
                    {
                        "name": "9. 复核喷淋管距离吊顶间间距，应为管外壁离吊顶上部面层间距净空是否小于50mm（应不小于50mm）。",

                    },
                    {
                        "name": "10. 复核给水PP-R管道与其他金属管道平行敷设时，净距离是否小于100mm（不宜小于100mm）， ",

                    },
                    {
                        "name": "11. 复核桥架在水管的上层或水平布置时的间距空间，桥架底部是否距离水管边缘或者保温边缘50mm以上。",

                    },
                    {
                        "name": "12. 管线外壁之间的最小距离是否小于100mm，管线阀门不宜并列安装，应错开位置，若需并列安装，净距不宜小于200mm； ",

                    },
                    {
                        "name": "13. 复核冷凝水排水管均有防结露层厚度是否满足25mm。",

                    },
                    {
                        "name": "14. 喷淋支管贴梁底敷设时，复核暖通风管上方预留喷淋支管敷设的空间是否满足100mm（应满足100mm）。",

                    },
                    {
                        "name": "15. 建筑物内埋地敷设的生活给水管和排水管之间的是否满足最小净距，平行埋设时不宜小于500mm，交叉埋设时不应小于 150mm，且给水管应在排水管的上面。室内冷、热水管上、下平行敷设时，冷水管应在热水管下方。",

                    },
                    {
                        "name": "16. 塑料给水管和排水管是否满足条件，不得敷设在灶台上边缘；明设的塑料给水立管距灶台边缘不得小于 400mm，距燃气热水器边缘不宜小于 200mm。",

                    },
                    {
                        "name": "17. 复核风管与桥架之间的净距离是否≥100mm。",

                    },
                    {
                        "name": "18. 对于管道的外壁、法兰边缘及热绝缘层外壁等管路最突出的部位，距墙壁或柱边的净距是否≥100mm； ",

                    },
                    {
                        "name": "19. 复核管道的外壁、法兰边缘及热绝缘层外壁等管路最突出的部位距墙壁或柱边的净距是否≥50mm。",

                    },
                    {
                        "name": "20. 复核风管顶部距离梁底的间距应是否≥50mm。",

                    },
                    {
                        "name": "21. 冷凝水是否考虑坡度，复核吊顶的实际安装高度。冷凝水管从风机盘管至水平干管坡度不小于0.01，冷凝水干管应按排水方向做不小于0.003的下行坡度。",

                    },
                    {
                        "name": "22. 复核空调冷冻水管、乙二醇管、空调风管、吊顶内的排烟风管和排烟油管是否设置保温，与可燃物的距离，不小于150mm 。",

                    },
                    {
                        "name": "23. 复核是否考虑风管法兰保温条宽度，一般可按35mm考虑。",

                    },
                    {
                        "name": "24. 吊顶区域，水阀风阀等操作开关位置是否靠近检修口，方便维修 ",

                    },
                    {
                        "name": "25. 暖通风口是否被其他管线遮挡 ",

                    },
                    {
                        "name": "26. 复核电缆线槽、桥架安装高度是否满足条件，宜高出地面2500mm以上。线槽和桥架顶部距顶棚或其它障碍物不宜小于300mm。",

                    },
                    {
                        "name": "27. 复核电缆桥架与易燃易爆气体管和热力管道敷设间距是否满足条件。",

                    },
                    {
                        "name": "28. 在吊顶内设置时，复核线槽盖开启面净空，是否保持80mm的垂直净空，与其他专业之间的距离最好保持在≥100mm ",

                    },
                    {
                        "name": "29. 复核电缆桥架与用电设备交越时，其间距是否小于500mm（应不小于500mm）。",

                    },
                    {
                        "name": "30. 两组电缆桥架在同高度平行敷设时，复核其间距是否小于300mm（应不小于300mm）。",

                    },
                    {
                        "name": "31. 复核桥架距墙壁或柱边净距，是否≥100mm。",

                    },
                    {
                        "name": "32. 电缆桥架多层安装时是否满足条件，控制电缆间距不小于200mm，电力电缆间距不小于200mm。弱电电缆与电力电缆间不小于500mm，如有屏蔽盖可减少到300mm，桥架上部距顶棚或其他障碍不小于300mm。",

                    },
                    {
                        "name": "33. 复核通信桥架距离其他桥架是否满足距离要求，水平间距至少300mm，垂直距离至少300mm，防止其它桥磁场干扰。",

                    },
                    {
                        "name": "34. 桥架上下翻时要放缓坡，复核角度是否控制在45°以下，桥架与其他管道平行间距≥100mm。",

                    },
                    {
                        "name": "35. 当有高、低压桥架上下安装时，复核高压桥架是否在低压桥架上方布置，且两者距离不小于500mm。",

                    },
                    {
                        "name": "36. 复核弱电线槽之间，间距是否小于100mm（应不小于100mm）。",

                    },
                    {
                        "name": "37. 复核弱电线槽与强电桥架之间，间距是否小于500mm（应不小于500mm）。",

                    },
                    {
                        "name": "38. 如强电采用接地金属线槽，复核弱电线槽与强电线槽之间间距是否小于300mm（应不小于300mm）。",

                    },
                    {
                        "name": "39. 若强弱电均采用接地金属线槽，复核弱电线槽和强电线槽之间间距是否小于80mm（应不小于80mm）。",

                    },
                    {
                        "name": "40. 复核桥架支架安装是否满足条件，水平安装的桥架支架间距宜为1500-3000mm，垂直安装的支架间距不应大于2000mm。",

                    }
                ]
            },
            {
                "name": "排布原则",
                "children": [
                    {
                        "name": "1. 是否考虑大管优先，大型高压桥架、母线优先的原则。",

                    },
                    {
                        "name": "2. 是否存在临时管线未避让长久管线的情况。",

                    },
                    {
                        "name": "3. 是否存在有压管道未避让无压管道的情况。",

                    },
                    {
                        "name": "4. 是否存在金属管线未避让非金属管线的情况。",

                    },
                    {
                        "name": "5. 是否存在有压水管未避让电气桥架，电气桥架未避让无压排水管线的情况。",

                    },
                    {
                        "name": "6. 是否存在消防水管未避让冷冻水管（同管径）的情况。",

                    },
                    {
                        "name": "7. 是否存在弱电管线未分设的情况。",

                    },
                    {
                        "name": "8. 是否存在冷水管道未避让热水管道的情况。",

                    },
                    {
                        "name": "9. 是否存在常温管道未避让低温、高温管道的情况。",

                    },
                    {
                        "name": "10. 是否存在附件少的管道未避让附件多的管道的情况。",

                    },
                    {
                        "name": "11. 是否存在各专业水管未平行敷设，出现超过两层上下敷设的情况。",

                    },
                    {
                        "name": "12. 存在大面积重叠时，是否有不需要开设风口的通风管道未避开设风口的通风管道、桥架、水管的情况。",

                    },
                    {
                        "name": "13. 不存在大面积重叠时，是否有水管、电缆桥架一般与风管未平行敷设的情况。",

                    },
                    {
                        "name": "14. 地下车库管综时最低净高要大于 2200mm,如管线过防火卷帘时能满足最低净高的前提下可以从防卷上方通过，如不能要进行避让。地上部分在满足净高的前提下可以从防火卷帘上方通过，或在其上方平行放置。",

                    },
                    {
                        "name": "15. 复核管线避让是是否弯头过多。",

                    },
                    {
                        "name": "16. 矩形管道向外侧延伸每个方向各100mm，圆形管道应至少比本身尺寸大2个等级的规格（并保证可以满足保温层厚度的需求）。",

                    },
                    {
                        "name": "17. 设备管道需要穿梁时，复核开洞尺寸，必须小于1/3梁高度，而且小于250mm，复核开洞位置，应位于梁高度的中心处。",

                    },
                    {
                        "name": "18. 是否存在重力管道穿越防火卷帘上方的情况。",

                    },
                    {
                        "name": "19. 是否存在给排水、电气桥架等穿过暖通风井的下方的情况。",

                    },
                    {
                        "name": "20. 是否存在管线密集的区域的建筑墙体独立开洞的情况。",

                    },
                    {
                        "name": "21. 复核设备专业留洞是否存在靠近墙边或者拐角处，碰到暗柱的情况。",

                    },
                    {
                        "name": "22. 复核带坡度的无压水管，不能上翻。除设计提升泵外，带坡度的无压水管不得出现倒坡。",

                    },
                    {
                        "name": "23. 虹吸雨水管顺水流方向不能上翻，管道不能呈上“凸”和下“凹”状。",

                    },
                    {
                        "name": "24. 是否存在附件多的避让附件少的管线。",

                    },
                    {
                        "name": "25. 复核水专业避让是否复核标准要求，给水管线在上，排水管线在下。保温管道在上，不保温管道在下，小口径管路应尽量支撑在大口径管路上方或吊挂在大管路下面。",

                    },
                    {
                        "name": "26. 复核污排、雨排、废水排水等重力排水管线是否存在上翻情况，重力污废水管线尽量贴梁底敷设。",

                    },
                    {
                        "name": "27. 复核水管与桥架层叠铺设时未放在桥架下方的情况。",

                    },
                    {
                        "name": "28. 是否存在水系统进入电气用房，如高低压电房、控制室、电梯机房等。",

                    },
                    {
                        "name": "29. 暖通的风管较多时，复核排烟管是否高于其他风管;大风管是否高于小风管。",

                    },
                    {
                        "name": "30. 复核空调主风管变标高，不允许不超过两次。",

                    },
                    {
                        "name": "31. 复核电缆桥架是否敷设在腐蚀性气体管道和热力管道的上方及腐蚀性液体管道的下方。",

                    },
                    {
                        "name": "32. 复核桥架是否存在穿越楼梯间、空调机房、管井、风井等的情况，遇到后尽量绕行。",

                    },
                    {
                        "name": "33. 复核电气避热避水的情况。确需与水管同侧上下敷设时，应安装在水管的上方；与热水管、蒸汽管平行上下敷设时，应敷设在热水管、蒸汽管的下方，间距应满足规范要求。",

                    },
                    {
                        "name": "34. 是否存在强电桥架进入弱电间（须避免电磁场效应）。",

                    }
                ]
            }
        ]
    }
]

export default kte_checklist_zh
